import { gql } from '@apollo/client';

export const constantContactCheckCredentialsQuery = gql`
  query ConstantContactCheckCredentials {
    constantContactCheckCredentials
  }
`;
